import React from 'react';

interface SubMenuItemProps {
  onClick: (e: React.MouseEvent) => void;
  children: React.ReactNode;
  className?: string;
}

/**
 * Generic submenu item component with consistent hover styling
 */
export const SubMenuItem: React.FC<SubMenuItemProps> = ({
  onClick,
  children,
  className = '',
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center justify-between gap-1 w-full p-6 cursor-pointer rounded hover:bg-moon-100 ${className}`}>
      {children}
    </div>
  );
};
